import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectEstimationByDealType } from '../../selectors/estimation';
import { EDealType } from '../../types/dealType';
import { TABS } from '../../constants/tabs';

/**
 * Проверяем доступность оценки
 *
 * Если текущий тип сделки продажа и данных об аренде нет:
 *  - значит таб аренды не доступен
 * Если текущий тип сделки аренда и данных о продаже нет:
 *  - значит таб продажи не доступен
 * Если не попали ни в одно условие:
 *  - значит данные у нас есть и для продажи и для аренды,
 *    либо пользователь плашку "Оценки по заданому адресу у нас нет" (табы не рендерятся на странице)
 */
export function useGetTabs() {
  const { data: saleEstimation } = useSelector(selectEstimationByDealType(EDealType.Sale));
  const { data: rentEstimation } = useSelector(selectEstimationByDealType(EDealType.Rent));

  return React.useMemo(() => {
    if (!rentEstimation && !saleEstimation) {
      return [];
    }

    const hasEstimations: Record<EDealType, boolean> = {
      [EDealType.Rent]: Boolean(rentEstimation),
      [EDealType.Sale]: Boolean(saleEstimation),
    };

    return TABS.map(tab => ({
      ...tab,
      disabled: !hasEstimations[tab.value],
    }));
  }, [rentEstimation, saleEstimation]);
}
